/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/* prettier-ignore-start */
/** @jsxRuntime classic */
/** @jsx createPlasmicElementProxy */
/** @jsxFrag React.Fragment */
// This class is auto-generated by Plasmic; please do not edit!
// Plasmic Project: 1xLhJbx5VveCXJsMYNxtFb
// Component: gQC3DIuIxMM-
import * as React from "react";
import {
  classNames,
  createPlasmicElementProxy,
  deriveRenderOpts,
  hasVariant,
  renderPlasmicSlot,
  useDollarState
} from "@plasmicapp/react-web";
import { useDataEnv } from "@plasmicapp/react-web/lib/host";
import ModuleNav from "../../ModuleNav"; // plasmic-import: wOh_p_z-r3kg/component
import SeparatorHorizontal from "../../SeparatorHorizontal"; // plasmic-import: vjwl8iKCk0Vg/component
import SeparatorVertical from "../../SeparatorVertical"; // plasmic-import: wGRnXZTfU7ft/component
import { _useStyleTokens } from "./PlasmicStyleTokensProvider"; // plasmic-import: 1xLhJbx5VveCXJsMYNxtFb/styleTokensProvider
import "@plasmicapp/react-web/lib/plasmic.css";
import projectcss from "./plasmic.module.css"; // plasmic-import: 1xLhJbx5VveCXJsMYNxtFb/projectcss
import sty from "./PlasmicSidenav.module.css"; // plasmic-import: gQC3DIuIxMM-/css

createPlasmicElementProxy;

export const PlasmicSidenav__VariantProps = new Array("layoutType");

export const PlasmicSidenav__ArgProps = new Array("logo", "tabs", "backButton");

const $$ = {};

function PlasmicSidenav__RenderFunc(props) {
  const { variants, overrides, forNode } = props;
  const args = React.useMemo(
    () =>
      Object.assign(
        {},
        Object.fromEntries(
          Object.entries(props.args).filter(([_, v]) => v !== undefined)
        )
      ),
    [props.args]
  );
  const $props = {
    ...args,
    ...variants
  };
  const $ctx = useDataEnv?.() || {};
  const refsRef = React.useRef({});
  const $refs = refsRef.current;
  const stateSpecs = React.useMemo(
    () => [
      {
        path: "layoutType",
        type: "private",
        variableType: "variant",
        initFunc: ({ $props, $state, $queries, $ctx }) => $props.layoutType
      }
    ],

    [$props, $ctx, $refs]
  );
  const $state = useDollarState(stateSpecs, {
    $props,
    $ctx,
    $queries: {},
    $refs
  });
  const styleTokensClassNames = _useStyleTokens();
  return (
    <div
      data-plasmic-name={"sidenav"}
      data-plasmic-override={overrides.sidenav}
      data-plasmic-root={true}
      data-plasmic-for-node={forNode}
      className={classNames(
        projectcss.all,
        projectcss.root_reset,
        projectcss.plasmic_default_styles,
        projectcss.plasmic_mixins,
        styleTokensClassNames,
        sty.sidenav
      )}
    >
      <div
        data-plasmic-name={"freeBox"}
        data-plasmic-override={overrides.freeBox}
        className={classNames(projectcss.all, sty.freeBox)}
      >
        <div
          data-plasmic-name={"moduleNavTop"}
          data-plasmic-override={overrides.moduleNavTop}
          className={classNames(projectcss.all, sty.moduleNavTop)}
        >
          {renderPlasmicSlot({
            defaultContents: (
              <ModuleNav
                className={classNames("__wab_instance", sty.moduleNav___039Lw)}
              />
            ),

            value: args.logo
          })}
        </div>
        <SeparatorHorizontal
          data-plasmic-name={"separatorHorizontal"}
          data-plasmic-override={overrides.separatorHorizontal}
          className={classNames("__wab_instance", sty.separatorHorizontal)}
        />

        <div
          data-plasmic-name={"tabsButtons"}
          data-plasmic-override={overrides.tabsButtons}
          className={classNames(projectcss.all, sty.tabsButtons, {
            [sty.tabsButtonslayoutType__default]: hasVariant(
              $state,
              "layoutType",
              "_default"
            )
          })}
        >
          {renderPlasmicSlot({
            defaultContents: null,
            value: args.tabs
          })}
        </div>
        <div
          data-plasmic-name={"moduleNavBottom"}
          data-plasmic-override={overrides.moduleNavBottom}
          className={classNames(projectcss.all, sty.moduleNavBottom)}
        >
          {renderPlasmicSlot({
            defaultContents: (
              <ModuleNav
                className={classNames("__wab_instance", sty.moduleNav__gchj)}
              />
            ),

            value: args.backButton
          })}
        </div>
      </div>
      <SeparatorVertical
        data-plasmic-name={"separatorVertical"}
        data-plasmic-override={overrides.separatorVertical}
        className={classNames("__wab_instance", sty.separatorVertical)}
      />
    </div>
  );
}

const PlasmicDescendants = {
  sidenav: [
    "sidenav",
    "freeBox",
    "moduleNavTop",
    "separatorHorizontal",
    "tabsButtons",
    "moduleNavBottom",
    "separatorVertical"
  ],

  freeBox: [
    "freeBox",
    "moduleNavTop",
    "separatorHorizontal",
    "tabsButtons",
    "moduleNavBottom"
  ],

  moduleNavTop: ["moduleNavTop"],
  separatorHorizontal: ["separatorHorizontal"],
  tabsButtons: ["tabsButtons"],
  moduleNavBottom: ["moduleNavBottom"],
  separatorVertical: ["separatorVertical"]
};

function makeNodeComponent(nodeName) {
  const func = function (props) {
    const { variants, args, overrides } = React.useMemo(
      () =>
        deriveRenderOpts(props, {
          name: nodeName,
          descendantNames: PlasmicDescendants[nodeName],
          internalArgPropNames: PlasmicSidenav__ArgProps,
          internalVariantPropNames: PlasmicSidenav__VariantProps
        }),
      [props, nodeName]
    );
    return PlasmicSidenav__RenderFunc({
      variants,
      args,
      overrides,
      forNode: nodeName
    });
  };
  if (nodeName === "sidenav") {
    func.displayName = "PlasmicSidenav";
  } else {
    func.displayName = `PlasmicSidenav.${nodeName}`;
  }
  return func;
}

export const PlasmicSidenav = Object.assign(
  // Top-level PlasmicSidenav renders the root element
  makeNodeComponent("sidenav"),
  {
    // Helper components rendering sub-elements
    freeBox: makeNodeComponent("freeBox"),
    moduleNavTop: makeNodeComponent("moduleNavTop"),
    separatorHorizontal: makeNodeComponent("separatorHorizontal"),
    tabsButtons: makeNodeComponent("tabsButtons"),
    moduleNavBottom: makeNodeComponent("moduleNavBottom"),
    separatorVertical: makeNodeComponent("separatorVertical"),
    // Metadata about props expected for PlasmicSidenav
    internalVariantProps: PlasmicSidenav__VariantProps,
    internalArgProps: PlasmicSidenav__ArgProps
  }
);

export default PlasmicSidenav;
/* prettier-ignore-end */
